export function initTips(context) {
  $(context).find('[data-tooltip]').powerTip({
    smartPlacement: true,
    mouseOnToPopup: true,
  });
}
